const t = /* @__PURE__ */ new WeakSet();
function n(e) {
  t.add(e);
}
function f(e) {
  return !t.has(e);
}
export {
  f as eventEffectNotPerformed,
  n as markEventEffectPerformed
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/event/index.js
// module id = 309
// module chunks = 41